import axioPath from '../../../api/axioPath';
import { UPDATE_DATA } from 'redux/actions/action_types'
import { showAppLoader, hideAppLoader } from '../app';
// import _ from 'lodash';

export const loadInventoryBagageInfo = (token) => (dispatch) => {
  return axioPath
    .get('/rfp/bagageInfo/get', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      return ex;
    });
};
export const orderBagageInfo = (token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/order/bagageInfo/get', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const loadInventoryBagageUpdate = (updateType, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/rfp/bagageInfo/update/isRead/' + updateType, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      return ex;
    });
};
export const loadInventoryOfferBagageUpdate = (updateType, token) => (dispatch) => {
  return axioPath
    .get('/rfp/bagageInfo/update/offer/isRead/' + updateType, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      return ex;
    });
};
export const orderBagageUpdate = (orderType, token) => (dispatch) => {
  return axioPath
    .get('/order/bagageInfo/update/isRead/' + orderType, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const notificationApi = (token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/rfp/notification/get', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader())
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const notificationApiV2 = (token, data) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath.post('/rfp/v2/notification/get_notifications', data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader())
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const notificationMarkReadApiV2 = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath.post('/rfp/v2/notification/mark_read', data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader())
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const notificationClearApiV2 = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath.post('/rfp/v2/notification/delete', data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader())
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const notificationCountApi = (token) => (dispatch) => {
  return axioPath
    .get('/rfp/v2/notification/get_all_notifications_count', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      return ex;
    });
};
export const maintenanceApi = (token) => (dispatch) => {
  return axioPath
    .get('/welcome/maintenaceValue', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader())
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      return ex;
    });
};

export const notificationUpdated = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/notification/update/isRead/' + id, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const orderUpdate = (token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/rfp/notification/update/load-inv/ORDER', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      return ex;
    });
};
export const bidUpdate = (token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/rfp/notification/update/load/requestType/BID', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      return ex;
    });
};
export const buyNowInventoryUpdate = (token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/rfp/notification/update/inventory/requestType/BUYNOW', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      return ex;
    });
};
export const offerLoadUpdate = (token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/rfp/notification/update/load/requestType/OFFER', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      return ex;
    });
};
export const offerInventoryUpdate = (token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/rfp/notification/update/inventory/requestType/OFFER', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      return ex;
    });
};
export const inventoryUpdate = (token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/rfp/notification/update/load-inv/INVENTORY', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      return ex;
    });
};
export const loadUpdate = (token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/rfp/notification/update/load-inv/LOAD', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      return ex;
    });
};
export const notificationPreferences = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/user/buyerPostLoadProfile/notificationPreferences', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};


export const notificationReadAll = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/notification/update/all', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const notificationClearAll = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/notification/update/delete/all', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const getUserStatesList = (token, email) => () => {
  return axioPath.get('/user/user_detail', {
    headers: {
      Authorization: `${token}`,
      userEmail: email
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      return ex;
    });
};
export const updateUserStatesList = (token, data) => () => {
  return axioPath.post('/user/update_newslettersStates', data, {
    headers: {
      Authorization: `${token}`,
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const clearIndependent = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/rfp/notification/update/delete/' + id, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
